import { Login } from '@myosh/myosh-login';
import { memo, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';

function LoginPage() {
  const navigate = useNavigate();

  const { search } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const username = searchParams.get('userName') || searchParams.get('username') || undefined;

  const onLoginSuccess = () => {
    void navigate('/');
  };

  return <Login onLoginSuccess={onLoginSuccess} username={username} />;
}

export default memo(LoginPage);
